import React from 'react';
import './App.css';
import BookingForm from './components/BookingForm';

function App() {
  return (
    <div className="App">
      <BookingForm />
    </div>
  );
}

export default App;

